import { render, staticRenderFns } from "./cartAndOrder_price.vue?vue&type=template&id=1b93d428&scoped=true"
import script from "./cartAndOrder_price.vue?vue&type=script&lang=js"
export * from "./cartAndOrder_price.vue?vue&type=script&lang=js"
import style0 from "./cartAndOrder_price.vue?vue&type=style&index=0&id=1b93d428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93d428",
  null
  
)

export default component.exports